import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const FeedbackEmotionScale2 = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 30C8.28 30 2 23.72 2 16C2 8.28 8.28 2 16 2C23.72 2 30 8.28 30 16C30 23.72 23.72 30 16 30ZM16 4C9.383 4 4 9.383 4 16C4 22.617 9.383 28 16 28C22.617 28 28 22.617 28 16C28 9.383 22.617 4 16 4Z" />
		<path d="M21.729 20.317C21.729 20.317 21.706 20.292 21.702 20.288C21.438 20.026 19.291 18 16 18C12.709 18 10.562 20.026 10.298 20.288C10.294 20.291 10.271 20.317 10.271 20.317C10.103 20.496 10 20.736 10 21C10 21.552 10.448 22 11 22C11.286 22 11.543 21.88 11.725 21.687C11.725 21.687 13.374 20 16 20C18.615 20 20.275 21.687 20.275 21.687C20.457 21.879 20.714 22 21 22C21.552 22 22 21.552 22 21C22 20.735 21.896 20.496 21.729 20.317Z" />
		<path d="M19 12C19.552 12 20 12.448 20 13C20 13.552 20.449 14 21 14C21.551 14 22 13.551 22 13C22 12.448 22.448 12 23 12C23.552 12 24 12.448 24 13C24 14.654 22.654 16 21 16C19.346 16 18 14.654 18 13C18 12.448 18.448 12 19 12Z" />
		<path d="M9 12C9.552 12 10 12.448 10 13C10 13.552 10.449 14 11 14C11.551 14 12 13.551 12 13C12 12.448 12.448 12 13 12C13.552 12 14 12.448 14 13C14 14.654 12.654 16 11 16C9.346 16 8 14.654 8 13C8 12.448 8.448 12 9 12Z" />
	</svg>
);

export default FeedbackEmotionScale2;
